import { CircleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { FieldFeedback, FieldLabel } from './FieldLabel';

interface FormFieldWrapperProps {
  label: string;
  explanation?: string;
  required?: boolean;
  fieldError?: string | null;
  showError?: boolean;
  className?: string;
  children: ReactNode;
}

export function FormFieldWrapper({
  label,
  explanation,
  required,
  fieldError,
  showError,
  className,
  children,
}: FormFieldWrapperProps) {
  return (
    <label className={twMerge('block', 'group', 'w-full', className)}>
      <FieldLabel label={label} required={required} explanation={explanation} />
      <div className="mt-1">{children}</div>
      {showError && fieldError && (
        <FieldFeedback className="mt-1">
          <CircleAlert aria-hidden="true" />
          <span className="truncate">{fieldError}</span>
        </FieldFeedback>
      )}
    </label>
  );
}
